import { makeShallowDefinition } from "./Category";

export namespace IndustryTypes {

    export const { Flat, FlatList, FlatEnum, FlatEnumList } = makeShallowDefinition({
        ELECTRICAL: {
            name: 'Elektrisk',
            description: 'Elektrisk',
        },
        GARDENING: {
            name: 'Hagearbeid',
            description: 'Hagearbeid',
        },
        CARPENTRY: {
            name: 'Snekring',
            description: 'Snekring',
        },
        PLUMBING: {
            name: 'Rørlegger',
            description: 'Rørlegger',
        },
    })

    export type IndustryTypes = typeof FlatEnum
    export type IndustryType = keyof typeof FlatEnum
}